import React, { Component } from 'react';
import './questionList.css';
import QuestionItem from '../questionItem';

class QuestionList extends Component {
  render() {
    return (
      <ul className="questions-pagination">
        {this.props.questions.map((item, index) => (
          <li key={index}>
            <QuestionItem
              numberQuestion={index + 1}
              index={index}
              activeQuestion={this.props.activeQuestion}
              changeActiveQuestion={this.props.changeActiveQuestion.bind(this)}
            />
          </li>
        ))}
        <li onClick={this.props.createQuestion}>+</li>
      </ul>
    );
  }
}

export default QuestionList;
